import bannerWave from '../assets/banner-wave.jpg';

// Web twin of PdfBannerBackdrop (BPP-231): the approved wave art, a left-to-right
// legibility scrim, and the gold bottom rail — so the app header matches the PDF
// banner. Render as the first child of a relatively-positioned, overflow-hidden
// banner container; siblings stack above it in DOM order.
export default function AppBannerBackdrop() {
  return (
    <>
      <img
        src={bannerWave}
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(90deg, rgba(9,20,40,0.9) 0%, rgba(9,20,40,0.55) 42%, rgba(9,20,40,0.15) 100%)',
        }}
      />
      <div
        className="absolute inset-x-0 bottom-0 h-[3px]"
        style={{ background: 'linear-gradient(90deg, #FBBF2B, #EDAA42)' }}
      />
    </>
  );
}
